import { Nullable } from 'legacy/lut/classes/models/utils'

export interface IFormattedFinanceOptions {
  withCurrencySign?: boolean
  minimumFractionDigits?: number
  maximumFractionDigits?: number
  signDisplay?: 'auto' | 'never' | 'always' | 'exceptZero'
}

/**
 * @deprecated
 * Use function from cng-common module:
 * cng-common/src/library/helpers/numbers/getFormattedFinance.ts
 * */
export const getFormattedFinance = (
  value?: Nullable<string | number>,
  options: IFormattedFinanceOptions = {}
) => {
  // TODO: add this check to function in cng-common
  if (value === null || value === undefined) {
    return '-'
  }

  const { withCurrencySign, maximumFractionDigits, minimumFractionDigits, signDisplay } = options

  const formatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    signDisplay,
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(Number(value))

  if (withCurrencySign) {
    return formatted
  }

  return formatted.replace('$', '')
}
